/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.accommodation.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.accommodation = {};
proto.witbooking.backoffice.accommodation.v1 = require('./accommodation_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse>}
 */
const methodDescriptor_AccommodationAPI_CreateAccommodation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.accommodation.v1.AccommodationAPI/CreateAccommodation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest,
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse>}
 */
const methodInfo_AccommodationAPI_CreateAccommodation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient.prototype.createAccommodation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/CreateAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_CreateAccommodation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient.prototype.createAccommodation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/CreateAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_CreateAccommodation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse>}
 */
const methodDescriptor_AccommodationAPI_CreateAccommodationCloneOnly = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.accommodation.v1.AccommodationAPI/CreateAccommodationCloneOnly',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest,
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse>}
 */
const methodInfo_AccommodationAPI_CreateAccommodationCloneOnly = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient.prototype.createAccommodationCloneOnly =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/CreateAccommodationCloneOnly',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_CreateAccommodationCloneOnly,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.accommodation.v1.CreateAccommodationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient.prototype.createAccommodationCloneOnly =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/CreateAccommodationCloneOnly',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_CreateAccommodationCloneOnly);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse>}
 */
const methodDescriptor_AccommodationAPI_UpdateAccommodation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.accommodation.v1.AccommodationAPI/UpdateAccommodation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest,
  proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse>}
 */
const methodInfo_AccommodationAPI_UpdateAccommodation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient.prototype.updateAccommodation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/UpdateAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_UpdateAccommodation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.accommodation.v1.UpdateAccommodationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient.prototype.updateAccommodation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/UpdateAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_UpdateAccommodation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse>}
 */
const methodDescriptor_AccommodationAPI_DeleteAccommodation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.accommodation.v1.AccommodationAPI/DeleteAccommodation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest,
  proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse>}
 */
const methodInfo_AccommodationAPI_DeleteAccommodation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient.prototype.deleteAccommodation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/DeleteAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_DeleteAccommodation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.accommodation.v1.DeleteAccommodationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient.prototype.deleteAccommodation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/DeleteAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_DeleteAccommodation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse>}
 */
const methodDescriptor_AccommodationAPI_ReorderAccommodation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.accommodation.v1.AccommodationAPI/ReorderAccommodation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest,
  proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse>}
 */
const methodInfo_AccommodationAPI_ReorderAccommodation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient.prototype.reorderAccommodation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/ReorderAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_ReorderAccommodation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.accommodation.v1.ReorderAccommodationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient.prototype.reorderAccommodation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/ReorderAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_ReorderAccommodation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse>}
 */
const methodDescriptor_AccommodationAPI_GetAccommodation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetAccommodation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest,
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse>}
 */
const methodInfo_AccommodationAPI_GetAccommodation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient.prototype.getAccommodation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_GetAccommodation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.accommodation.v1.GetAccommodationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient.prototype.getAccommodation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetAccommodation',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_GetAccommodation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse>}
 */
const methodDescriptor_AccommodationAPI_GetAccommodations = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetAccommodations',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest,
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse>}
 */
const methodInfo_AccommodationAPI_GetAccommodations = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient.prototype.getAccommodations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetAccommodations',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_GetAccommodations,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.accommodation.v1.GetAccommodationsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient.prototype.getAccommodations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetAccommodations',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_GetAccommodations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse>}
 */
const methodDescriptor_AccommodationAPI_GetAccommodationCategoryLimits = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetAccommodationCategoryLimits',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest,
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse>}
 */
const methodInfo_AccommodationAPI_GetAccommodationCategoryLimits = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient.prototype.getAccommodationCategoryLimits =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetAccommodationCategoryLimits',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_GetAccommodationCategoryLimits,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.accommodation.v1.GetAccommodationCategoryLimitsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient.prototype.getAccommodationCategoryLimits =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetAccommodationCategoryLimits',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_GetAccommodationCategoryLimits);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse>}
 */
const methodDescriptor_AccommodationAPI_GetEngineCategoryLimits = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetEngineCategoryLimits',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest,
  proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest,
 *   !proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse>}
 */
const methodInfo_AccommodationAPI_GetEngineCategoryLimits = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse,
  /**
   * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIClient.prototype.getEngineCategoryLimits =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetEngineCategoryLimits',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_GetEngineCategoryLimits,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.accommodation.v1.GetEngineCategoryLimitsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.accommodation.v1.AccommodationAPIPromiseClient.prototype.getEngineCategoryLimits =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.accommodation.v1.AccommodationAPI/GetEngineCategoryLimits',
      request,
      metadata || {},
      methodDescriptor_AccommodationAPI_GetEngineCategoryLimits);
};


module.exports = proto.witbooking.backoffice.accommodation.v1;

